import InfoIndicator from '@ubnt/link-core-ui/components/InfoIndicator/InfoIndicator';
import bytesFormatter from '@ubnt/ui-components/utils/bytesFormatter';
import { memo, useMemo } from 'react';

import { Text, TextProps } from '@ubnt/ui-components/aria/Typography/Text';
import { Flex } from 'components/Flex';
import { useTooltipWidth } from 'hooks/useTooltipWidth';

export interface MCSProps {
  infoText: string;
  mcs?: number;
  signalLabelParams?: {
    label: TextProps['children'];
    color: TextProps['color'];
  };
  phyRate?: number;
}

const MCS = (props: MCSProps) => {
  const { infoText, mcs, phyRate, signalLabelParams } = props;
  const tooltipWidth = useTooltipWidth();

  const rateString = useMemo(() => {
    if (!phyRate) {
      return undefined;
    }
    return bytesFormatter((phyRate * 1000000) / 8, 'bitrate');
  }, [phyRate]);

  return (
    <Flex justifyBetween alignCenter>
      <Flex gap="xs" alignCenter>
        <Text size="small">
          <span>MCS </span>
          <span>{mcs ?? '-'}</span>
          <span>{rateString ? ` (${rateString} Air Speed)` : ''}</span>
        </Text>
        <InfoIndicator severity="info2" tooltipWidth={tooltipWidth} maxWidth={tooltipWidth}>
          {infoText}
        </InfoIndicator>
      </Flex>
      {signalLabelParams != null && (
        <Text size="small" color={signalLabelParams.color}>
          {signalLabelParams.label}
        </Text>
      )}
    </Flex>
  );
};

const MemoizedMCS = memo(MCS);

export default MemoizedMCS;
